import { classnames } from '@ygtechnologies/bygr-frontend-component-library';
import React from 'react';
import { SystemInfo } from 'services/system';
import theme from './TopEnvironmentBar.module.scss';

interface TopEnvironmentBarProps {
    systemInfo: SystemInfo;
}

const TopEnvironmentBar: React.FC<TopEnvironmentBarProps> = ({ systemInfo }) => {
    return (
        <div className={classnames(theme.topBar, theme[systemInfo.environmentName.toLowerCase()])}>
            {systemInfo.environmentName}
        </div>
    );
};

export default TopEnvironmentBar;
